import { BaseApi } from '@/main/baseApi';
import { ZAKAZKA_ZAPUJCKA, NAME as ZAKAZKA } from '@/modules/servis/zakazka/constants';
import { NAME as SERVIS } from '@/modules/servis/constants';

import { NAME as VozidloPujcovnyName } from '../vozidloPujcovna/constants';
import { DMS_MODULE, DependentTableNames, NAME, POLOZKY } from './constants';
import { NAME as HLASENI_O_SKODE } from './hlaseniOSkode/constants';

class ZapujckaProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case POLOZKY:
				return `/${this.area}/${HLASENI_O_SKODE}/${POLOZKY}Schema`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Schema`;
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case POLOZKY:
				return `/${this.area}/${HLASENI_O_SKODE}/${POLOZKY}Rows`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Rows`;
		}
	}

	async createFromPlanovanaPujcka(planpujcpaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CreateFromPlanpujcpa`, { planpujcpaId });
	}

	async getVozidloPujcovna(VozidlopaId: number) {
		return this.fetch(`/${DMS_MODULE}/${VozidloPujcovnyName}/${VozidlopaId}`);
	}

	async vozidloChange(ZapujckaData: object) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaVozidla`, ZapujckaData);
	}

	async zakaznikChange(ZapujckaData: object) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaZakaznika`, ZapujckaData);
	}

	async predmetChange(Zapujcka: object) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaPredmet`, Zapujcka);
	}

	async getZakazkaId(PujcovnapaId: object) {
		return this.fetch(`/${SERVIS}/${ZAKAZKA_ZAPUJCKA}/GetZakazkaId`, PujcovnapaId);
	}

	async rozsireniProtokoluCheck(ZapujckaData: object) {
		return this.post(`/${DMS_MODULE}/${NAME}/RozsireniProtokoluCheck`, ZapujckaData);
	}

	async zapujckaRozsireniProtokolu(ZapujckaData: object) {
		return this.post(`/${DMS_MODULE}/${NAME}/RozsireniProtokolu`, ZapujckaData);
	}

	async getFaktPristDatNext(params: object) {
		return this.postQuery(`/${DMS_MODULE}/${NAME}/GetFaktPristDatNext`, params);
	}

	async getNajemniSmlouvaReport(filter: {}) {
		return this.fetchPdf(`/${DMS_MODULE}/Reports/GetNajemniSmlouvaReport`, filter);
	}

	async getInforSouhlasConnReport(filter: {}) {
		return this.fetchReport('GetInforSouhlasConnReport', filter);
	}
}

export const apiProvider = new ZapujckaProvider(DMS_MODULE, NAME);
